import { gql } from "@apollo/client";

//ADD BOOKINGJOURNEY at the end of query, subscription and mutation for supporting booking journey

export const ADD_UPDATE_DELETE_EVENTS = gql`
  mutation AddEventsFromBookingJourney($bookingId: string, $body: EventRequest) {
    addEventsFromBookingJourney(body: $body)
      @rest(type: "EventResponse", path: "/Events", method: "put", bodyKey: body) {
      bookingId
      bookingNo
      events {
        id
        eventId
        bookingId
        validationError
        externalEventId
        isDeleted
        creationMethod
        courseId
        eventCategory
        eventChannel
        eventSpecialised
        team
        dateEventRequested
        country
        virtualDelivery
        topicName
        topicId
        location
        bookVenue
        cost
        sessionMinCapacity
        sessionMaxCapacity
        activityId
        agreedStartDate
        alternativeDates
        agreedEndDate
        agreedStartTime
        agreedEndTime
        duration
        subscribeToNewsLetter
        supplierReferenceNumber
        eventNotes
        requestedSupplierName
        venueType
        vat
        anyNonStandardRequirements
        contextualisationRequired
        isProgramme
        noOfDelegates
        appianPriceId
        currency
        isValid
        dateType
        venue
      }
    }
  }
`;

export const ADD_EventsAndVenues = gql`
  mutation AddEventsAndVenueFromBookingJourney($bookingId: string, $body: EventRequest) {
    addEventsAndVenueFromBookingJourney(body: $body)
      @rest(type: "EventResponse", path: "/Venues/EventsAndVenues", method: "put", bodyKey: body) {
      bookingId
      bookingNo
      events {
        id
        eventId
        bookingId
        validationError
        externalEventId
        isDeleted
        creationMethod
        courseId
        eventCategory
        eventChannel
        eventSpecialised
        team
        dateEventRequested
        country
        virtualDelivery
        topicName
        topicId
        location
        bookVenue
        cost
        sessionMinCapacity
        sessionMaxCapacity
        activityId
        agreedStartDate
        alternativeDates
        agreedEndDate
        agreedStartTime
        agreedEndTime
        duration
        subscribeToNewsLetter
        supplierReferenceNumber
        eventNotes
        requestedSupplierName
        venueType
        vat
        anyNonStandardRequirements
        contextualisationRequired
        isProgramme
        noOfDelegates
        appianPriceId
        currency
        dateType
        isValid
        venue
      }
    }
  }
`;
export const GET_BASKET_DETAILS_BY_BOOKER = gql`
  query GetBasketDetailsByBookerForBookingJourney {
    getBasketDetailsByBookerForBookingJourney
      @rest(type: "EventResponse", path: "/Basket", method: "GET") {
      id
      bookingId
      events {
        id
        eventId
        bookingId
        validationError
        externalEventId
        isDeleted
        creationMethod
        courseId
        eventCategory
        eventChannel
        eventSpecialised
        team
        dateEventRequested
        country
        virtualDelivery
        topicName
        topicId
        location
        bookVenue
        cost
        sessionMinCapacity
        sessionMaxCapacity
        activityId
        agreedStartDate
        agreedEndDate
        agreedStartTime
        agreedEndTime
        duration
        subscribeToNewsLetter
        supplierReferenceNumber
        eventNotes
        requestedSupplierName
        venueType
        vat
        anyNonStandardRequirements
        contextualisationRequired
        isProgramme
        noOfDelegates
        priceId
        currency
        isValid
        isBookerDelegate
        dateType
        venue
        host
        delegateDetails
        purchaseOrder
        costCentre
        approvalId
        businessUnit
        appianPriceId
        alternativeDates
      }
    }
  }
`;
export const ADD_UPDATE_HOST_DELEGATES = gql`
  mutation AddUpdateHostDelegatesFromBookingJourney($bookingId: string, $body: EventRequest) {
    addUpdateHostDelegatesFromBookingJourney(body: $body)
      @rest(type: "EventResponse", path: "/Events/HostAndDelegates", method: "put", bodyKey: body) {
      bookingId
      bookingNo
      events {
        id
        eventId
        bookingId
        isDeleted
        isValid
        creationMethod
        courseId
        eventCategory
        sessionMinCapacity
        sessionMaxCapacity
        host
        delegateDetails
      }
    }
  }
`;

export const ADD_UPDATE_EVENT_PURCHASEORDER = gql`
  mutation AddUpdateEventPOFromBookingJourney($bookingId: string, $body: EventRequest) {
    addUpdateEventPOFromBookingJourney(body: $body)
      @rest(
        type: "EventResponse"
        path: "/Events/EventsAndPurchaseOrders"
        method: "put"
        bodyKey: body
      ) {
      bookingId
      bookingNo
      events {
        id
        eventId
        bookingId
        isValid
        creationMethod
        purchaseOrder
        costCentre
        approvalId
        businessUnit
      }
    }
  }
`;

export const SUBMIT_EVENT = gql`
  query SubmitBookingFromBookingJourney($bookingId: string, $bookingRequest: EventRequest) {
    submitBookingFromBookingJourney(bookingRequest: $bookingRequest, bookingId: $bookingId)
      @rest(
        type: "ResponseModel"
        path: "/Bookings/{args.bookingId}/SubmitExternalEventRequest"
        method: "GET"
      ) {
      result
      hasErrors
    }
  }
`;

export const GET_COMPLETED_BOOKINGS = gql`
  query GetCompletedBookingEventsForBookingJourney($body: EventRequest) {
    getCompletedBookingEventsForBookingJourney(body: $body)
      @rest(type: "EventResponse", path: "/CompletedBookingEvents", method: "POST", bodyKey: body) {
      id
      eventId
      bookingNo
      externalEventId
      bookingId
      courseId
      eventCategory
      eventChannel
      dateEventRequested
      topicName
      location
      cost
      currency
      sessionMinCapacity
      sessionMaxCapacity
      agreedStartDate
      agreedStartTime
      agreedEndDate
      dateType
      eventNotes
      venue
      host
      delegateDetails
      purchaseOrder
      eventStatus
      alternativeDates
      topicId
      activityId
      appianPriceId
      isValid
    }
  }
`;
export const GET_PO_SAS_URL = gql`
  mutation GetSasUrlForPoFromBookingJourney($bookingId: String, $body: GetPurchaseOrderSasRequest) {
    getSasUrlForPoFromBookingJourney(body: $body, bookingId: $bookingId)
      @rest(
        type: "PurchaseOrderUploadSas"
        path: "/PurchaseOrderSas/{args.bookingId}"
        method: "post"
        bodyKey: body
      ) {
      sas
      uploadTypeKey
      uploadTypeValue
      fileRelativePath
      customMetadata
    }
  }
`;
export const TRIGGER_PO_VIRUS_SCAN = gql`
  mutation ScanUploadedPurchaseOrderFromBookingJourney(
    $bookingId: String
    $body: ScanUploadedPurchaseOrderRequestModel
  ) {
    scanUploadedPurchaseOrderFromBookingJourney(body: $body, bookingId: $bookingId)
      @rest(
        type: "PurchaseOrderModel"
        path: "/Bookings/{args.bookingId}/ScanPurchaseOrderFile"
        method: "post"
        bodyKey: body
      ) {
      id
      po
      costCentre
      approvalId
      businessUnit
      fileName
      link
      bookingId
      virusScanResult
      eventId
    }
  }
`;

export const CHECK_OR_EXPRESS_INTEREST = gql`
  mutation CheckOrExpressInterestFromBookingJourney($body: ExpressInterestInput) {
    checkOrExpressInterestFromBookingJourney(body: $body)
      @rest(
        type: "ExpressInterest"
        path: "/CheckOrExpressInterest"
        method: "POST"
        bodyKey: body
      ) {
      id
      isInterestExists
    }
  }
`;
